import { Pill } from "@clipboard-health/ui-components";
import { type Theme } from "@mui/material/styles";

/**
 * Compact pill displaying "Cancelled" status on shift cards.
 * Positioned at the top-left of the card following the same pattern
 * as "Leave now" / "Urgent" pills on open shift cards.
 * Uses disabled intent colors (warm grey) for a muted appearance.
 */
export function CancellationStatusPill() {
  return (
    <Pill
      variant="filled"
      size="small"
      label="Cancelled"
      backgroundColor={(theme: Theme) =>
        theme.palette.intent?.disabled.background ?? theme.palette.grey[100]
      }
      color={(theme: Theme) => theme.palette.intent?.disabled.text ?? theme.palette.text.secondary}
      iconType="block-shift"
      iconColor={(theme: Theme) =>
        theme.palette.intent?.disabled.icon ?? theme.palette.text.secondary
      }
      sx={{ width: "fit-content" }}
    />
  );
}
